<app-back-header 
  [headerText]="'Torna alla dashboard'" 
  (backAction)="backToDashboard()" 
  class="sticky-top">
</app-back-header>

<h3 class="ms-2 mt-2 mb-3">Importa Fattura Elettronica</h3>

<div class="upload-container col-md-6">
    
  <form [formGroup]="uploadForm" (ngSubmit)="onSubmit()">
    <div class="form-group">
      <label for="xmlFile" class="mat-form-field-label mb-3">File XML:</label>
      
      <!-- Drag & Drop Area -->
      <div 
        class="drop-zone"
        [class.drop-zone--over]="isDragOver"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)"
        (click)="fileInput.click()">
        
        <div class="drop-zone-content">
          <mat-icon class="drop-zone-icon">cloud_upload</mat-icon>
          
          <div *ngIf="!selectedFile" class="drop-zone-text">
            <p class="mb-1">Trascina qui il file XML</p>
            <!-- <small class="text-muted">oppure</small>
            <button 
              mat-stroked-button 
              type="button"
              class="mt-2"
              (click)="$event.stopPropagation()">
              <mat-icon>attach_file</mat-icon>
              Seleziona dal dispositivo
            </button> -->
          </div>
          
          <div *ngIf="selectedFile" class="selected-file">
            <mat-icon class="file-icon">description</mat-icon>
            <div class="file-info">
              <strong>{{ selectedFile.name }}</strong>
              <small class="text-muted d-block">
                Dimensione: {{ (selectedFile.size / 1024).toFixed(2) }} KB
              </small>
            </div>
            <button 
              mat-icon-button 
              color="warn"
              (click)="removeFile($event)"
              class="remove-btn">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </div>
      </div>
      
      <!-- Hidden file input -->
      <input 
        #fileInput
        type="file" 
        id="xmlFile"
        (change)="onFileSelected($event)" 
        accept=".xml"
        style="display: none"
        required>
      
      <div *ngIf="!selectedFile" class="mt-3">
        <small class="form-text text-muted">
          Seleziona una Fattura Elettronica XML, poi premi il pulsante "Importa" in basso.
        </small>
      </div>
      <div *ngIf="!selectedFile" class="mt-3">
        <small class="form-text text-muted">
          I dati della fattura verranno controllati in automatico e importati.
        </small>
      </div>
    </div>

    <div *ngIf="selectedFile" class="mt-3 data-preview-card">
      <p class="data-preview-title">Dati della fattura da importare</p>
      <ul class="list-unstyled mb-0">
        <li class="data-preview-row">
          <mat-icon class="data-preview-icon">calendar_today</mat-icon>
          <span class="data-preview-label">Data di emissione</span>
          <strong>{{ invoiceDate }}</strong>
        </li>
        <li class="data-preview-row">
          <mat-icon class="data-preview-icon">tag</mat-icon>
          <span class="data-preview-label">Numero progressivo</span>
          <strong>{{ invoiceNumber }}</strong>
        </li>
        <li class="data-preview-row">
          <mat-icon class="data-preview-icon">business</mat-icon>
          <span class="data-preview-label">Cliente / Beneficiario</span>
          <strong>{{ invoiceCompany }}</strong>
        </li>
        <li class="data-preview-row">
          <mat-icon class="data-preview-icon">euro</mat-icon>
          <span class="data-preview-label">Importo totale</span>
          <strong>€ {{ formatToItalian(invoiceTotal) }}</strong>
        </li>
      </ul>
    </div>

    <div class="mt-3 form-actions d-flex justify-content-end gap-2">
      <button 
        mat-raised-button
        type="submit" 
        [disabled]="!uploadForm.valid || isUploading || !selectedFile"
        color="primary">
        <mat-icon>upload</mat-icon>
        {{ isUploading ? 'Importando...' : 'Importa XML' }}
      </button>
    </div>

    <div *ngIf="uploadProgress > 0" class="progress mt-3">
      <div 
        class="progress-bar" 
        [style.width]="uploadProgress + '%'">
        {{ uploadProgress }}%
      </div>
    </div>

    <div *ngIf="uploadError" class="alert alert-danger mt-3">
      {{ uploadError }}
    </div>

    <div *ngIf="!uploadSuccess">
      </div>

    <div *ngIf="uploadSuccess" class="alert alert-success mt-3">
      <div class="d-flex align-items-center mb-3">
        <mat-icon class="me-2 flex-shrink-0">check_circle</mat-icon>
        <strong>Fattura N.{{invoiceNumber}} emessa a favore di {{invoiceCompany}} importata con successo!</strong>
      </div>

      <div class="d-flex gap-2">
        <button mat-flat-button color="primary" (click)="navigateToInvoices()">
          <mat-icon>list</mat-icon> Vai alle fatture
        </button>
        
        <button mat-stroked-button (click)="prepareNewUpload()">
          <mat-icon>refresh</mat-icon> Carica un'altra
        </button>
      </div>
    </div>

  </form>
</div>
